/* eslint-disable react/display-name */
import { Box, Divider, Flex, Stack } from '@chakra-ui/react';
import { memo, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { collection, query, where, onSnapshot, doc, setDoc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { EnterAndExit } from '../organisms/EnterAndExit';
import { UserCard } from '../molecules/UserCard';
import { useLoginUser } from '../../hooks/provders/useLoginUserPrvider';
import { useMessage } from '../../hooks/useMessage';

export const Home = memo(() => {
  const [onlineUsers, setOnlineUsers] = useState([]);
  const { loginUser } = useLoginUser();
  const { showMessage } = useMessage();
  const { uid } = loginUser;
  const hasHandledNfcStatus = useRef(false);  // フラグを追加


  useEffect(() => {
    const handleNfcUserStatus = async () => {
      const urlSearchparams = new URLSearchParams(window.location.search);
      const nfcId = urlSearchparams.get('nfc');
  
      if (nfcId === 'true' && !hasHandledNfcStatus.current) {
        hasHandledNfcStatus.current = true;  // 初回実行後にフラグを立てる
        try {
          // ユーザーのドキュメント参照を取得
          const userRef = doc(db, 'users', uid);
          const userDoc = await getDoc(userRef);
  
          if (userDoc.exists()) {
            const currentUserOnline = userDoc.data().isOnline;
            await setDoc(
              userRef,
              {
                isOnline: !currentUserOnline,
              },
              { merge: true }
            ).then(() => {
              console.log('入室/退室ステータスを更新しました');
            if(currentUserOnline) {
              showMessage({ title: '退室しました', status: 'success' });
            } else {
              showMessage({ title: '入室しました', status: 'success' });
            }
          });
  
            // URLから?nfc=trueを削除
            const newUrl = window.location.origin + window.location.pathname;
            window.history.replaceState(null, '', newUrl);
          } else {
            console.log("ユーザードキュメントが存在しません");
          }
        } catch (error) {
          console.error("入室/退室ステータスの更新に失敗しました:", error);
        }
      }
    };
  
    if (uid) {
      handleNfcUserStatus();  // 非同期処理を呼び出す
    }
  }, [uid, showMessage]);

  useEffect(() => {
    const fetchOnlineUsers = async () => {
      const q = query(collection(db, 'users'), where('isOnline', '==', true));
      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const onlineUsersData = querySnapshot.docs.map((doc) => doc.data());
        setOnlineUsers(onlineUsersData);
      });
      return () => unsubscribe();
    };
    fetchOnlineUsers();
  }, []);

  return (
    <Flex align="center" justify="center" hight="100vh" py={4}>
      <Box bg="white" w="xl" h="auto" minH="xl" p={4} borderRadius="md" shadow="md">
        <SAcctiveUser as="h1" size="lg" textAlign="center">
          現在の入室者数：
          <span>{onlineUsers.filter((user) => user.isOnline).length}</span>
        </SAcctiveUser>
        <Divider mt={3} />
        <Stack spacing={5} py={4} px={10}>
          <UserCard onlineUsers={onlineUsers} />
          <Box display="flex" justifyContent="center" flexWrap="wrap">
            <EnterAndExit />
          </Box>
        </Stack>
      </Box>
    </Flex>
  );
});

const SAcctiveUser = styled.p`
  text-align: center;
  font-size: 1.1rem;
  span {
    font-size: 1.2rem;
    font-weight: bold;
  }
`;
